export const FIELD_MAP = {
  comercio: "shopName",
  shop: "shopName",
  nombre: "firstName",
  name: "firstName",
  firstname: "firstName",
  apellido: "lastName",
  lastname: "lastName",
  correo: "email",
  email: "email",
  emailaddress: "email",
  teléfono: "phoneNumber",
  telefono: "phoneNumber",
  celular: "phoneNumber",
  phone: "phoneNumber",
  phonenumber: "phoneNumber",
  "númerodecontacto(representantelegal)": "phoneNumber",
  contacto: "contactName",
  correoelectrónicocontacto: "email",
  estadodelexpediente: "expState",
  establecimientos: "shops",
  categoria: "category",
  category: "category",
  accountnumber: "accountNumber",
  account: "accountNumber",
  streetaddress: "streetAddress", //este campo no esta en la base creo
  invitationemailsent: "invitationEmailSent", //este campo no esta en la base creo
  comments: "comments", //este campo no esta en la base creo
  accountvalidation: "accountValidation",
  initialdepositbonusreceived: "initialBonus",
  date: "dateTime",
  fecha: "dateTime",
  contrato: "contractType",
  ip: "ipAddress",
  "ip verification": "verificationIP",
  "verificación de ip": "verificationIP",
  "name verification": "verificationName",
  "verificación de nombre": "verificationName",
  "email verification": "verificationEmail",
  "verificación de correo": "verificationEmail",
  "phone number verification": "verificationPhoneNumber",
  "verificación de número de teléfono": "verificationPhoneNumber",
  "address verification": "verificationAddress",
  "verificación de dirección": "verificationAddress",
  "street address": "streetAddress",
  dirección: "streetAddress",
};

export const STATUS_RECORD_MAP = {
  complete: "cmp",
  discharged: "dsc",
  incomplete: "inc",
  notDefined: "ntd",
  notAnswered: "nta",
  pending: "pnd",
  pendiente: "pnd",
  completo: "cmp",
  dadodebaja: "dsc",
  incompleto: "inc",
  nodefinido: "ntd",
  norespondido: "nta",
};

export const CONTRACT_TYPE_MAP = {
  digital: "dg",
  físico: "ph",
  fisico: "ph",
  escaneado: "sc",
  planes: "pl",
  notienefirma: "nsg",
};

export const TEMPORALITY_MAP = {
  permanente: "prm",
  temporal: "tmp",
};

export const CONTRACT_MAP = {
  beneficios: "benefits",
  fecha_ref: "dateRef",
  fechadeúltimarenovación: "dateLastRenovation",
  fechadeultimarenovacion: "dateLastRenovation",
  fechadepublicación: "datePublish",
  fechadepublicacion: "datePublish",
  fechadeingreso: "dateJoin",
  fechadevencimiento: "dateExpiration",
  renovadopor: "renovationBy",
  ejecutivo: "executive",
  contrato: "contractType",
  temporalidad: "temporality",
  estadoderenovación: "renovationState",
  estadoderenovacion: "renovationState",
  planes: "planes",
  davivienda: "davivienda",
  instacredit: "instacredit",
  vallepaz: "vallePaz",
  comercio: "contractName",
};
